import { WNATIVE, Token, ChainId } from '@cryptoalgebra/kim-sdk';
import { STABLECOINS } from '@app/constants/tokens';

type ChainTokenList = {
  readonly [chainId: number]: Token[];
};

export const WMATIC_EXTENDED: { [chainId: number]: Token } = {
  ...WNATIVE
};

const WETH_ONLY: ChainTokenList = Object.fromEntries(
  Object.entries(WMATIC_EXTENDED).map(([key, value]) => [key, [value]])
);

export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.Base]: [...WETH_ONLY[ChainId.Base]],
  [ChainId.Mode]: [
    ...WETH_ONLY[ChainId.Mode],
    STABLECOINS.USDC,
    STABLECOINS.USDT
  ]
};
